import { api } from '@/api/client'
import type { LoginRequest, LoginResponse, RefreshTokenResponse, Usuario } from '@/types/api'

export async function login(credentials: LoginRequest): Promise<LoginResponse> {
  const { data } = await api.post<LoginResponse>('/login', credentials)
  return data
}

export async function refreshSession(refreshToken: string): Promise<RefreshTokenResponse> {
  const { data } = await api.post<RefreshTokenResponse>('/refresh', {
    refresh_token: refreshToken,
  })
  return data
}

export async function fetchMe(): Promise<Usuario> {
  const { data } = await api.get<Usuario>('/me')
  return data
}
